exports.install = function (Vue, options) {
  Vue.prototype.sortBykey = function(ary, key){
    return ary.sort(function (a, b) {
      let x = a[key]
      let y = b[key]
      return ((x < y) ? -1 : (x > y) ? 1 : 0)
    })
  };
  Vue.prototype.imgFileCheck = function (file) {
    let postfixes = ['jpg', 'png']
    let string = file.name
    let index = string.lastIndexOf('.')
    let length = string.length
    let postfix = string.substring(index + 1, length)
    let result = postfixes.indexOf(postfix)
    let boolean = false
    const isLt2M = file.size / 1024 / 1024 < 2
    if (result >= 0) {
      boolean = true
    }
    if (!boolean) {
      this.$message({
        message: '上传的图片只能是jpg/png格式!',
        type: 'warning'
      })
    }
    if (!isLt2M) {
      this.$message.warning('上传的文件大小不能超过 2MB!')
      return false;
    }
    return boolean
  }
  Vue.prototype.dateFormat = function(fmt, date){
    let ret;
    let opt = {
      "Y+": date.getFullYear().toString(),        // 年
      "m+": (date.getMonth() + 1).toString(),     // 月
      "d+": date.getDate().toString(),            // 日
      "H+": date.getHours().toString(),           // 时
      "M+": date.getMinutes().toString(),         // 分
      "S+": date.getSeconds().toString()          // 秒
      // 有其他格式化字符需求可以继续添加，必须转化成字符串
    };
    for (let k in opt) {
      ret = new RegExp("(" + k + ")").exec(fmt);
      if (ret) {
        fmt = fmt.replace(ret[1], (ret[1].length == 1) ? (opt[k]) : (opt[k].padStart(ret[1].length, "0")))
      };
    };
    return fmt;
  }
  Vue.prototype.wordFileCheck = function (file) {
    let postfixes = ['doc', 'docx']
    let string = file.name
    let index = string.lastIndexOf('.')
    let length = string.length
    let postfix = string.substring(index + 1, length)
    let result = postfixes.indexOf(postfix)
    let boolean = false
    const isLt2M = file.size / 1024 / 1024 < 10
    if (result >= 0) {
      boolean = true
    }
    if (!boolean) {
      this.$message({
        message: '上传的文档只能是doc/docx格式!',
        type: 'warning'
      })
    }
    if (!isLt2M) {
      this.$message.warning('上传的文件大小不能超过 10MB!')
      return false;
    }
    return boolean
  }
  Vue.prototype.excelFileCheck = function (file) {
    let postfixes = ['xls', 'xlsx']
    let string = file.name
    let index = string.lastIndexOf('.')
    let length = string.length
    let postfix = string.substring(index + 1, length)
    let result = postfixes.indexOf(postfix)
    let boolean = false
    const isLt2M = file.size / 1024 / 1024 < 10
    if (result >= 0) {
      boolean = true
    }
    if (!boolean) {
      this.$message({
        message: '上传的excel只能是xls/xlsx格式!',
        type: 'warning'
      })
    }
    if (!isLt2M) {
      this.$message.warning('上传的文件大小不能超过 10MB!')
      return false;
    }
    return boolean
  }
  Vue.prototype.pdfFileCheck = function (file) {
    let postfixes = ['pdf']
    let string = file.name
    let index = string.lastIndexOf('.')
    let length = string.length
    let postfix = string.substring(index + 1, length)
    let result = postfixes.indexOf(postfix)
    let boolean = false
    const isLt2M = file.size / 1024 / 1024 < 10
    if (result >= 0) {
      boolean = true
    }
    if (!boolean) {
      this.$message({
        message: '上传的PDF只能是pdf格式!',
        type: 'warning'
      })
    }
    if (!isLt2M) {
      this.$message.warning('上传的文件大小不能超过 10MB!')
      return false;
    }
    return boolean
  }
  Vue.prototype.pptFileCheck = function (file) {
    let postfixes = ['ppt', 'pptx']
    let string = file.name
    let index = string.lastIndexOf('.')
    let length = string.length
    let postfix = string.substring(index + 1, length)
    let result = postfixes.indexOf(postfix)
    let boolean = false
    const isLt2M = file.size / 1024 / 1024 < 10
    if (result >= 0) {
      boolean = true
    }
    if (!boolean) {
      this.$message({
        message: '上传的幻灯片只能是ppt/pptx格式!',
        type: 'warning'
      })
    }
    if (!isLt2M) {
      this.$message.warning('上传的文件大小不能超过 10MB!')
      return false;
    }
    return boolean
  }
  Vue.prototype.vedioFileCheck = function (file) {
    let postfixes = ['mp4', 'avi','rmvb','mov']
    let string = file.name
    let index = string.lastIndexOf('.')
    let length = string.length
    let postfix = string.substring(index + 1, length)
    let result = postfixes.indexOf(postfix)
    let boolean = false
    const isLt2M = file.size / 1024 / 1024 < 200
    if (result >= 0) {
      boolean = true
    }
    if (!boolean) {
      this.$message({
        message: '上传的视频只能是mp4/avi/rmvb/mov格式!',
        type: 'warning'
      })
    }
    if (!isLt2M) {
      this.$message.warning('上传的文件大小不能超过 200MB!')
      return false;
    }
    return boolean
  }
  Vue.prototype.voiceFileCheck = function (file) {
    let postfixes = ['mp3']
    let string = file.name
    let index = string.lastIndexOf('.')
    let length = string.length
    let postfix = string.substring(index + 1, length)
    let result = postfixes.indexOf(postfix)
    let boolean = false
    const isLt2M = file.size / 1024 / 1024 < 20
    if (result >= 0) {
      boolean = true
    }
    if (!boolean) {
      this.$message({
        message: '上传的音频只能是mp3格式!',
        type: 'warning'
      })
    }
    if (!isLt2M) {
      this.$message.warning('上传的文件大小不能超过 20MB!')
      return false;
    }
    return boolean
  }
  Vue.prototype.otherFileCheck = function (file) {

    const isLt2M = file.size / 1024 / 1024 < 50

    if (!isLt2M) {
      this.$message.warning('上传的文件大小不能超过 50MB!')
      return false;
    }
  }
};



// WEBPACK FOOTER //
// ./src/components/utils/baseUtil.js